import JobsTableLayout from "@/pages/_layouts/jobs/JobsTableLayout";
import { ServiceLevel } from "@/pages/_layouts/jobs/types";

export default function ExecuSearchJobsPage() {
  return (
    <JobsTableLayout
      columnHeaders={{
        title: true,
        facility: true,
        serviceLevel: true,
        totalCompensation: false,
        employer: true,
        owner: false,
        postedOn: true,
        submissionDeadline: true,
        applicantCount: true,
        postingStage: true,
        jobStatus: true,
        section: true
      }}
      filters={{
        postingStage: true,
        jobStatus: true,
        serviceLevel: true,
        postedDateRange: true,
        section: true,
        owner: false
      }}
      defaultValues={{
        stage: [],
        serviceLevel: [ServiceLevel.ADVANCED, ServiceLevel.EXECUTIVE]
      }}
      defaultSort={[{ id: "goLiveTime", desc: true }]}
    />
  );
}
